export const sitemap = [
    {
      title: "Platform",
      links: [
        { label: "Features", path: "/#features" },
        { label: "How it Works", path: "/#how-it-works" },
        { label: "Testimonials", path: "/#testimonials" },
        { label: "FAQ", path: "/faq" }
      ]
    },
    {
      title: "Resources",
      links: [
        { label: "Why Community Portal?", path: "/why-community-portal" },
        { label: "About Us", path: "/about-us" },
        { label: "Blog", path: "/blog" },
        { label: "Privacy", path: "/privacy" }
      ]
    },
    {
      title: "Support",
      links: [
        { label: "Help Articles", path: "/help" },
        { label: "Contact Us", path: "/contact-us" },
        { label: "Terms & Conditions", path: "/terms" },
        { label: "Sitemap", path: "/sitemap" }
      ]
    },
    {
      title: "Company",
      links: [
        { label: "AMG Corp", path: "https://amgcorp.com", external: true },
        { label: "Careers", path: "/careers" },
        { label: "Events", path: "/events" },
        { label: "Investors", path: "/investors" }
      ]
    }
  ];
  